// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__tnO6o","right":"styles_right__3ZUQ4"};